export const TARIFFICATOR_BILLING_PRODUCT_ID = 'tarifficator';
